
<template>
	<div class="wrapper">
		<headerTag />
		<div class="kefuCon">
			<div>
				<p class="yewu">
					<i class="kefu_gszc"></i>
					<span>公司注册</span>
				</p>
				<p class="conTxt">
					<span class="txt">电话：</span>
					<a class="telphone" href="tel:13761492454">13761492454</a>
				</p>
				<p class="conTxt">
					<span class="txt">微信：</span>
					<span class="weix" id="copyValue1">wupaoqifu-03</span>
				</p>
				<button @click="copy" data-agl-cvt="32" class="copybtn" data-clipboard-action="copy" data-clipboard-target="#copyValue1">复制微信号</button>
			</div>
			<div>
				<p class="yewu">
					<i class="kefu_swch"></i>
					<span>税务筹划</span>
				</p>
				<p class="conTxt">
					<span class="txt">电话：</span>
					<a class="telphone" href="tel:13761293423">13761293423</a>
				</p>
				<p class="conTxt">
					<span class="txt">微信：</span>
					<span class="weix" id="copyValue2">wupaoqifu-02</span>
				</p>
				<button @click="copy" data-agl-cvt="32" class="copybtn" data-clipboard-action="copy" data-clipboard-target="#copyValue2">复制微信号</button>
			</div>
			<div>
				<p class="yewu">
					<i class="kefu_qybg"></i>
					<span>企业变更</span>
				</p>
				<p class="conTxt">
					<span class="txt">电话：</span>
					<a class="telphone" href="tel:13761492454">13761492454</a>
				</p>
				<p class="conTxt">
					<span class="txt">微信：</span>
					<span class="weix" id="copyValue3">wupaoqifu-03</span>
				</p>
				<button @click="copy" data-agl-cvt="32" class="copybtn" data-clipboard-action="copy" data-clipboard-target="#copyValue3">复制微信号</button>
			</div>
			<div>
				<p class="yewu">
					<i class="kefu_dzdjz"></i>
					<span>定制代记账</span>
				</p>
				<p class="conTxt">
					<span class="txt">电话：</span>
					<a class="telphone" href="tel:13761293423">13761293423</a>
				</p>
				<p class="conTxt">
					<span class="txt">微信：</span>
					<span class="weix" id="copyValue4">wupaoqifu-02</span>
				</p>
				<button @click="copy" data-agl-cvt="32" class="copybtn" data-clipboard-action="copy" data-clipboard-target="#copyValue4">复制微信号</button>
			</div>
			<div>
				<p class="yewu">
					<i class="kefu_dljz"></i>
					<span>代理记账</span>
				</p>
				<p class="conTxt">
					<span class="txt">电话：</span>
					<a class="telphone" href="tel:13761479254">13761479254</a>
				</p>
				<p class="conTxt">
					<span class="txt">微信：</span>
					<span class="weix" id="copyValue5">zero17491438</span>
				</p>
				<button @click="copy" data-agl-cvt="32" class="copybtn" data-clipboard-action="copy" data-clipboard-target="#copyValue5">复制微信号</button>
			</div>
			<div>
				<p class="yewu">
					<i class="kefu_cszx"></i>
					<span>财税咨询</span>
				</p>
				<p class="conTxt">
					<span class="txt">电话：</span>
					<a class="telphone" href="tel:13817014478">13817014478</a>
				</p>
				<p class="conTxt">
					<span class="txt">微信：</span>
					<span class="weix" id="copyValue6">Qifu_99</span>
				</p>
				<button @click="copy" data-agl-cvt="32" class="copybtn" data-clipboard-action="copy" data-clipboard-target="#copyValue6">复制微信号</button>
			</div>
			<div class="shouhou">
				<p class="yewu">
					<i class="kefu_shouhou"></i>
					<span>售后服务与投诉建议</span>
				</p>
				<div class="con">
					<p class="conTxt">
						<span class="txt">电话：</span>
						<a class="telphone" href="tel:15821374933">15821374933</a>
					</p>
					<p class="conTxt">
						<span class="txt">微信：</span>
						<span class="weix" id="copyValue7">15821374933</span>
					</p>
					<button @click="copy" data-agl-cvt="32" class="copybtn" data-clipboard-action="copy" data-clipboard-target="#copyValue7">复制微信号</button>
				</div>
			</div>
		</div>
		<div style="clear:both;"></div>
		<div class="kefuCon1">
			<p>
				<img src="../../assets/images/kefu/kf_rexian.png" alt="" />
				<span>服务热线：15918923845</span>
				<a href="tel:15918923845">
					<img src="../../assets/images/kefu/kf_phone.png" alt=""/>
					立即拨打
				</a>
			</p>
			<p>
				<img src="../../assets/images/kefu/kf_time.png" alt="" />
				<span>工作时间：9:00-18:00</span>
			</p>
		</div>
		<footerTag />
	</div>

</template>

<script>
   
    import "../../assets/css/kefu.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import footerTag from '@/components/footerTag/footerTag.vue'
	
	import { findCustomer,openConsult } from '../../assets/js/common.js' 
	import Clipboard from 'clipboard'

	export default {
		name: 'kefuPage',
		props: {
        
		},
		components: {
			headerTag,
			footerTag,
		},
		data(){
			return {
			}
		},
		methods:{
			runThis(type){
				let _this=this;
				findCustomer(type,function(data){
					openConsult(data)
				},()=>{
					_this.$message.error({message: '暂无客服人员'});
				})
			},
			copy(){
				var clipboard = new Clipboard('.copybtn', {
					text: function () {
						//return $('.copybtn').text();
					}
				});
						
				clipboard.on('success', e => {  
					this.$message.success({message: '已复制成功，快去微信添加好友吧~~',customClass:'mzindex'});
					// 释放内存  
					clipboard.destroy()  
				})  
				clipboard.on('error', e => {  
					// 不支持复制 
					this.$message.error({message: '抱歉哦，复制失败请手动复制微信号~~',customClass:'mzindex'});
					// 释放内存  
					clipboard.destroy()  
				})  
					
			}
		}
	}

</script>